export const IMPORT = "import";
export const SYNC = "sync";

export const getIntegrationType = (datasourceType) => {
  if (datasourceType === "jiraTeamsExport") {
    return SYNC;
  }
  return IMPORT;
};
